import React, { useState, useEffect } from 'react'
import ContactForm from '../components/ContactForm'

export default function Contact() {
  const [pageData, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Set metadata
    document.title = "Kontakt - Frejlev Auto v/ Jacob Kvist"
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute('content', "Kontakt Frejlev Auto v/ Jacob Kvist. Ring på 30 34 50 96 eller besøg os på Svenstrupvej 39, 9200 Aalborg SV.")
    }

    // Fetch page content from CMS
    fetch('https://api.dev.auxo.dk/public/by-slug/da/kontakt-frejlev-auto')
      .then(res => res.json())
      .then(data => {
        setPage(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Error fetching contact page:', err)
        setLoading(false)
      })
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 py-12 md:py-20 text-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumbs */}
        <div className="text-xs text-gray-500 uppercase tracking-wider mb-6 flex items-center gap-2">
          <span>Forside</span>
          <i className="fa-solid fa-chevron-right text-[8px]"></i>
          <span className="text-[#5cbe4f] font-semibold">Kontakt</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* Left: Contact Info & Map */}
          <div className="lg:col-span-7 space-y-8 bg-white p-6 sm:p-10 rounded-2xl border border-gray-200 shadow-sm">
            {loading ? (
              <div className="space-y-4 animate-pulse">
                <div className="h-8 bg-gray-200 rounded w-3/4"></div>
                <div className="h-4 bg-gray-200 rounded w-full"></div>
                <div className="h-4 bg-gray-200 rounded w-5/6"></div>
              </div>
            ) : pageData ? (
              <div className="space-y-6">
                <h1 className="text-3xl sm:text-4xl font-black text-gray-950 tracking-tight">
                  Kontakt Frejlev Auto
                </h1>
                <div className="h-1 w-20 bg-[#5cbe4f] rounded mb-6"></div>
                
                <div 
                  className="rich-text"
                  dangerouslySetInnerHTML={{ 
                    __html: pageData.content.replace(/<h1[^>]*>.*?<\/h1>/i, '') 
                  }}
                />
              </div>
            ) : (
              <div className="text-center py-12">
                <p className="text-gray-500">Kunne ikke indlæse indholdet. Prøv igen senere.</p>
              </div>
            )}

            {/* Quick Contact Box */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4 border-t border-gray-200">
              <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
                <div className="flex items-center gap-3 text-sm">
                  <div className="w-10 h-10 rounded-lg bg-[#5cbe4f]/15 text-[#5cbe4f] flex items-center justify-center text-lg shrink-0">
                    <i className="fa-solid fa-phone"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 font-semibold uppercase">Ring til os</p>
                    <a href="tel:+4530345096" className="text-gray-900 font-bold hover:text-[#5cbe4f]">
                      30 34 50 96
                    </a>
                  </div>
                </div>
              </div>

              <div className="p-4 rounded-xl bg-gray-50 border border-gray-200">
                <div className="flex items-center gap-3 text-sm">
                  <div className="w-10 h-10 rounded-lg bg-[#5cbe4f]/15 text-[#5cbe4f] flex items-center justify-center text-lg shrink-0">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500 font-semibold uppercase">Skriv til os</p>
                    <a href="mailto:frejlevauto@gmail.com" className="text-gray-900 font-bold hover:text-[#5cbe4f] text-xs">
                      frejlevauto@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Map */}
            <div className="w-full h-64 sm:h-80 rounded-xl overflow-hidden border border-gray-200 shadow-sm">
              <iframe
                title="Frejlev Auto Beliggenhed"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115636.13318756905!2d9.716999084128203!3d57.01253171820594!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4649337e2403e3c1%3A0xa58a3cb996e00a4a!2sFrejlev%20Auto!5e0!3m2!1sen!2sdk!4v1782305122760!5m2!1sen!2sdk"
                className="w-full h-full border-0"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="lg:col-span-5">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  )
}
